import style from './index.module.scss';
import Button from '../../button/block';
import { Skeleton } from '@mui/material';
import { useTranslation } from 'react-i18next';

function ArticleTile({ content, showInspector = true, showToolBar = true }) {
    const { t } = useTranslation();

    return (
        <div className={style.block} href={content.link}>
            <a href={content.link}>
                {((content.featured_media !== 0 && content.featured_media) || content.thumbnail) && (
                    <img
                        alt={content._embedded ? content._embedded['wp:featuredmedia'][0].alt_text : content.title}
                        src={
                            content._embedded ? content._embedded['wp:featuredmedia'][0].source_url : content.thumbnail
                        }
                        className={style.image}
                    />
                )}
                <h3
                    className={style.title}
                    dangerouslySetInnerHTML={{
                        __html: content.title.rendered ? content.title.rendered : content.title,
                    }}
                />
            </a>
            <div>
                <p
                    className={style.excerpt}
                    dangerouslySetInnerHTML={{
                        __html: content.excerpt.rendered ? content.excerpt.rendered : content.excerpt,
                    }}
                />
                <Button
                    text={t('Lire la suite')}
                    aspect="ghost"
                    color={true}
                    link={content.link}
                    showInspector={showInspector}
                    showToolBar={showToolBar}
                />
            </div>
        </div>
    );
}

export const LoadingTile = () => {
    return (
        <article className={style.blockSkeleton}>
            <Skeleton variant="rectangular" width="100%" height={200} />
            <Skeleton />
            <Skeleton />
            <Skeleton />
        </article>
    );
};

export default ArticleTile;
